import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import ContentHeader from "../components/ContentHeader"
import ContentMain from "../components/ContentMain"
import ContentWrapper from "../components/ContentWrapper"
import API from "../utils/API"
import Sweetalert from "../utils/Sweetalert"
import AiTargetingStatsSection from "../components/AiTargetingStats/AiTargetingStatsSection"

export default function MainHome() {
  // State
  const [userData, setUserData] = useState({})

  // Comportement
  useEffect(() => {
    API.GET(
      "/user/data",
      (response) => {
        setUserData(response.data)
      },
      (errorMessage) => {
        setUserData({})
        Sweetalert.fireErrorToast(errorMessage)
      }
    )
  }, [])

  // Rendu
  return (
    <ContentWrapper>
      <ContentHeader>
        <div className="col-sm-6">
          <h1 className="m-0">Tableau de bord</h1>
        </div>
        <div className="col-sm-6">
          <ol className="breadcrumb float-sm-right">
            <li className="breadcrumb-item active">Tableau de bord</li>
          </ol>
        </div>
      </ContentHeader>
      <ContentMain>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-3 col-6">
              <div className="small-box bg-info">
                <div className="inner">
                  <h3>{userData.adCount ? userData.adCount : <i className="fas fa-2x fa-sync-alt fa-spin"></i>}</h3>

                  <p>Ressource{userData.adCount > 1 && "s"}</p>
                </div>
                <div className="icon">
                  <i className="fas fa-play"></i>
                </div>
                <Link to="/ressources" className="small-box-footer">
                  Voir mes ressources <i className="fas fa-arrow-circle-right"></i>
                </Link>
              </div>
            </div>
            <div className="col-lg-3 col-6">
              <div className="small-box bg-success">
                <div className="inner">
                  <h3>
                    {userData.totemCount ? userData.totemCount : <i className="fas fa-2x fa-sync-alt fa-spin"></i>}
                  </h3>

                  <p>Écran{userData.totemCount > 1 && "s"}</p>
                </div>
                <div className="icon">
                  <i className="fas fa-desktop"></i>
                </div>
                <Link to="/diffusion" className="small-box-footer">
                  Je veux diffuser <i className="fas fa-arrow-circle-right"></i>
                </Link>
              </div>
            </div>
            <div className="col-lg-3 col-6">
              <div className="small-box bg-warning">
                <div className="inner">
                  <h3>
                    {userData.adBroadcastedCount ? (
                      userData.adBroadcastedCount
                    ) : (
                      <i className="fas fa-2x fa-sync-alt fa-spin"></i>
                    )}
                  </h3>

                  <p>Diffusion{userData.adBroadcastedCount > 1 && "s"}</p>
                </div>
                <div className="icon">
                  <i className="fas fa-broadcast-tower"></i>
                </div>
                <Link to="/diffusion" className="small-box-footer">
                  Je veux diffuser <i className="fas fa-arrow-circle-right"></i>
                </Link>
              </div>
            </div>
            <div className="col-lg-3 col-6">
              <div className="small-box bg-danger">
                <div className="inner">
                  <h3>
                    {userData.teamUserCount ? (
                      userData.teamUserCount
                    ) : (
                      <i className="fas fa-2x fa-sync-alt fa-spin"></i>
                    )}
                  </h3>

                  <p>Membre{userData.teamUserCount > 1 && "s"} dans mon équipe</p>
                </div>
                <div className="icon">
                  <i className="fas fa-user"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="card card-primary card-outline">
                <div className="card-header">
                  <h5 className="card-title">News</h5>
                </div>
                <div className="card-body">
                  <p className="card-text">
                    La planification est maintenant accessible ! Rendez-vous dans l'onglet{" "}
                    <Link to="/diffusion">diffusion</Link> pour en profiter.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AiTargetingStatsSection />
      </ContentMain>
    </ContentWrapper>
  )
}
